import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { AuthFacade } from '@rd/core/auth/store/facades/auth.facade';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { RewardsProgramSchemes } from '../types';
import { RewardsProgramsViewFacade } from '../views/facade/rewards-program-view.facade';

@Injectable()
export class RewardsProgramsGuard {
  constructor(
    private router: Router,
    private rewardsProgramViewFacade: RewardsProgramsViewFacade,
    private authFacade: AuthFacade,
    private actions$: Actions,
  ) {}
  isLoggedIn$: Observable<boolean> = this.authFacade.isLoggedIn$;

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.isLoggedIn$.pipe(
      switchMap((isLoggedIn) => {
        if (!isLoggedIn) {
          return of(true);
        }
        return this.rewardsProgramViewFacade.selectedScheme$.pipe(
          map((selectedScheme) => selectedScheme === RewardsProgramSchemes.Bnz),
        );
      }),
      tap((v) => !v && this.router.navigate(['rewards_programs'])),
    );
  }
}
